(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.jsApiList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports["default"] = void 0;
  var _default = [// needed by wechat work
  "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareWechat", // ------------
  "updateTimelineShareData", "updateAppMessageShareData", "onMenuShareQQ", "onMenuShareWeibo", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "translateVoice", "downloadVoice", "scanQRCode", "getLocation", "openLocation"];
  _exports["default"] = _default;
});
//# sourceMappingURL=jsApiList.js.map